import { render, staticRenderFns } from "./FedexReturn.vue?vue&type=template&id=19aacffa&scoped=true"
import script from "./FedexReturn.vue?vue&type=script&lang=js"
export * from "./FedexReturn.vue?vue&type=script&lang=js"
import style0 from "./FedexReturn.vue?vue&type=style&index=0&id=19aacffa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19aacffa",
  null
  
)

export default component.exports